import React from 'react';
export const CTASection = () => {
  return <section id="cta" className="w-full py-12 bg-green-900/10" data-id="element-68">
      <div className="container mx-auto px-4" data-id="element-69">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-6 text-center" data-id="element-70">
          Try Risk-Free for 90 Days
        </h2>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-71">
          We're so confident The Daily Foundation Chew™ will transform your
          dog's health from the inside out that we guarantee it:
        </p>
        <div className="bg-amber-50 p-6 rounded-lg shadow-md mb-8 max-w-3xl mx-auto" data-id="element-72">
          <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-73">
            Our "Tail-Wagging" Promise:
          </h3>
          <ul className="text-green-900/80 space-y-3" data-id="element-74">
            <li className="flex items-start" data-id="element-75">
              <span className="text-yellow-700 mr-2" data-id="element-76">✓</span>
              <span data-id="element-77">
                90-Day Money-Back Guarantee - See results or get a full refund
              </span>
            </li>
            <li className="flex items-start" data-id="element-78">
              <span className="text-yellow-700 mr-2" data-id="element-79">✓</span>
              <span data-id="element-80">Free Shipping on all U.S. orders</span>
            </li>
            <li className="flex items-start" data-id="element-81">
              <span className="text-yellow-700 mr-2" data-id="element-82">✓</span>
              <span data-id="element-83">30-Day Supply in every jar</span>
            </li>
            <li className="flex items-start" data-id="element-84">
              <span className="text-yellow-700 mr-2" data-id="element-85">✓</span>
              <span data-id="element-86">Made in USA in FDA-registered facilities</span>
            </li>
          </ul>
        </div>
        <h3 className="text-xl font-bold text-green-900 mb-6 text-center" data-id="element-87">
          Special Limited-Time Offer: Choose Your Savings Below
        </h3>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-88">
          Because when your dog's gut is healthy, everything else falls into
          place. Better digestion. Calmer skin. Easier movement. More energy.
          The dog you remember.
        </p>
        <div className="flex flex-col items-center gap-4 mb-8" data-id="element-89">
          <a href="https://snoutyco.com/products/the-daily-foundation-chew" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-4 px-10 rounded-full text-xl shadow-md transition duration-300 w-full max-w-lg text-center" data-id="element-90">
            BEST VALUE: SUBSCRIBE & SAVE 20% TODAY
          </a>
          <a href="https://snoutyco.com/products/the-daily-foundation-chew" className="text-green-900 hover:text-yellow-700 font-semibold" data-id="element-91">
            Or, Try One Jar without Subscribe
          </a>
        </div>
        <p className="text-green-900/80 text-center" data-id="element-92">
          Join thousands of pet parents who've discovered that true health
          starts in the gut.
        </p>
      </div>
    </section>;
};